import Matching from './Matching';
import OneChoice from './OneChoice';
import SelectWord from './SelectWord';
import Underlined from './Underlined';
import Unscramble from './Unscramble';
import Conjugation from './Conjugation';
import FillInTheBlank from './FillInTheBlank';
import MatchingTwoColumn from './MatchingTwoColumn';
import FillWordInTheBlank from './FillWordInTheBlank';
import FillLetterInTheBlank from './FillLetterInTheBlank';
import SelectWordsInSentence from './SelectWordsInSentence';
import PuzzleWords from './PuzzleWords';

import TickTF from './TickTF';
import SelectWordInImage from './SelectWordInImage';
import FillInTheBlankWithHint from './FillInTheBlankWithHint';

export default {
  Matching,
  OneChoice,
  SelectWord,
  Underlined,
  Unscramble,
  Conjugation,
  MatchingTwoColumn,
  FillInTheBlank,
  FillWordInTheBlank,
  FillLetterInTheBlank,
  FillInTheBlankWithHint,
  SelectWordsInSentence,
  PuzzleWords,
  TickTF,
  SelectWordInImage,
};
